import { ConfigProvider } from "antd"
import { getParentEl } from "../../util/varibles/constants"
import { IPropsChildren } from "../../util/varibles/interface"

export const ConfigAnt: React.FC<IPropsChildren> = ({ children }) => {
    return <ConfigProvider
        getPopupContainer={getParentEl}
        theme={{
            token: {
                colorPrimary: 'var(--colorActive)',
                colorText: 'var(--colorMain)',
                colorTextSecondary: '#C9C',
            },
            components: {
                InputNumber: {
                    borderRadius: 24,
                },
                Typography: {
                    colorTextDescription: 'var(--colorSub)',
                    fontSize: 15,
                },
                Select: {
                    hoverBorderColor: 'var(--colorActive)',
                    activeBorderColor: 'var(--colorActive)',
                    colorTextPlaceholder: 'var(--colorSub)',
                    selectorBg: 'transparent',
                    optionActiveBg: 'var(--borderIcon)',
                    colorText: 'var(--colorMain)',
                    colorBorder: 'var(--borderIcon)'
                },
                Checkbox: {
                    colorPrimary: 'var(--colorActive)',
                    colorBorder: 'var(--colorActive)',
                    colorBgContainer: 'transparent',
                    colorPrimaryHover: 'transparent',
                },
                Radio: {
                    colorPrimary: 'var(--colorActive)',
                },
                Button: {
                    colorText: 'var(--colorMain)',
                    primaryColor: 'var(--colorMain)'
                }
            }
        }}
    >
        {children}
    </ConfigProvider>
}

export default ConfigAnt
